import template from './oldBankInput.html';
import controller from './oldBankInput.controller';

export const oldBankInputComponent = {
  name: 'oldBankInput',
  restrict: 'E',
  bindings: {
    form: '<',
    model: '=',
    title: '<',
    pretitle: '<',
  },
  template,
  controllerAs: 'vm',
  controller
};



// WEBPACK FOOTER //
// ./src/app/common/ui/oldBankInput/oldBankInput.component.js